/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const brandNameByCode = {
    1001: '1-800-Flowers ',
    1019: 'Harry & David',
    1009: '1800baskets',
    1025: 'Simply Chocolate',
    1010: 'Fruit Bouquets',
    1012: 'Cheryls',
    1022: 'Personalization Universe',
    1002: 'The Popcorn Factory',
    1020: 'Wolferman\'s',
    1018: 'Stock Yards',
    1027: 'The Market',
    1029: 'Shari\'s Berries',
    1030: 'Personalization Mall',
    1031: 'Vital Choice',
    1033: 'Things Remembered',
    1034: 'Florists',
    1036: 'Card Isle',
    1038: 'Celebrations',
};

const brandByCode = {
    1001: '1800flowers',
    1019: 'harryanddavid',
    1009: '1800baskets',
    1025: 'simplychocolate',
    1010: 'fruitbouquets',
    1012: 'cheryls',
    1022: 'personalizationuniverse',
    1002: 'thepopcornfactory',
    1020: 'wolfermans',
    1018: 'stockyards',
    1030: 'personalizationmall',
    1031: 'vitalchoice',
    1027: 'themarket',
    1033: 'thingsremembered',
    1034: 'Florists',
    1036: 'Card Isle',
    1038: 'Celebrations',
};

export const orderServiceEmail = {
    '18F': '',
    HD: 'service@harryanddavid.com',
    '18B': '',
    CCO: 'customerservice@cheryls.com',
    TPF: 'customerservice@thepopcornfactory.com',
    SCH: '',
    SY: 'myorder@stockyards.com',
    WLF: 'service@wolfermans.com',
    FB: '',
    BRY: '',
    TMP: '',
    HLN: '',
    PMA: '',
    PML: 'customerservice@personalizationmall.com',
    VC: 'service@vitalchoice.com',
    FL: '',
    CI: 'customerservice@cardisle.com',
    CSG: 'custserv@celebrations.com',
};

const calendarMapPresentation = {
    1001: 'flower', // 1800flowers
    1019: 'food', // harryanddavid
    1009: 'flower', // 1800baskets
    1025: 'food', // simplychocolate
    1010: 'flower', // fruitbouquets
    1012: 'food', // cheryls
    1022: 'flower', // personalizationuniverse
    1002: 'food', // thepopcornfactory
    1020: 'food', // wolfermans
    1018: 'food', // stockyards
    1030: 'flower', // personalizationmall
    1029: 'flower', // berries
    1031: 'food', // vitalchoice'
    1027: 'flower', // the market'
    1033: 'flower', // thingsremembered
    1034: 'flower', // florists
    1036: 'flower', // cardisle
    1038: 'flower', // celebrations
};

const propertiesTypeByProduct = {
    1001: 'flower', // 1800flowers
    1019: 'food', // harryanddavid
    1009: 'flower', // 1800baskets
    1025: 'food', // simplychocolate
    1010: 'flower', // fruitbouquets
    1012: 'food', // cheryls
    1022: 'flower', // personalizationuniverse
    1002: 'food', // thepopcornfactory
    1020: 'food', // wolfermans
    1018: 'food', // stockyards
    1029: 'flower', // berries
    1030: 'personalization', // personalizationmall
    1031: 'food', // 'vitalchoice',
    1027: 'flower', // 'the market',
    1033: 'personalization', // thingsremembered
    1034: 'flower', // florists
    1036: 'flower', // cardisle
    1038: 'flower', // celebrations
};

const skuBuilderWithDash = (sku) => {
    let lastDashIndex = 0;
    const endIndex = sku.length;
    for (let i = 0; i < sku.length; i += 1) {
        if (sku[i] === '-') {
            lastDashIndex = i + 1;
        }
    }

    return sku.slice(lastDashIndex, endIndex);
};

const skuBuilderWithUnderscore = (sku) => {
    const firstUnderscoreIndex = sku.indexOf('_');
    return sku.slice(firstUnderscoreIndex + 1, sku.length);
};

const skuProductBuilder = (sku) => {
    if (sku.indexOf('-') !== -1) {
        return skuBuilderWithDash(sku);
    }
    return skuBuilderWithUnderscore(sku);
};

const getProductBaseCodeSku = (sku) => {
    let productSku = sku;

    if (productSku.indexOf('-') >= 0) {
        productSku = sku.split('-');
        if (productSku.length > 0) {
            // Get the last position that have the base code.
            productSku = productSku[productSku.length - 1];
        }
    }
    return productSku;
};

const getNormalizeGiftMessageGCI = (orderItem) => {
    let giftMessageGciData = {};

    if (orderItem.greetingCards?.length > 0) {
        const greetingCards = orderItem.greetingCards[0] || [];
        const price = parseFloat(orderItem.itemInfo?.price || 0).toFixed(2);

        const type = greetingCards.greetingCardType === 'CI' ? 'ci' : 'cgc';
        giftMessageGciData = {
            data: {
                type,
                thumbnail: greetingCards?.greetingCardImage || '',
                text: greetingCards.greetingMessage?.greetingMessage || '',
                price: `$${price}`,
                gciItemId: greetingCards.cartItemId,
                gciKeyId: greetingCards.greetingCardType || '',
            },
        };

        if (giftMessageGciData.data.thumbnail) {
            giftMessageGciData.data.thumbnail = giftMessageGciData.data.thumbnail.replace('width=63', 'width=120');
        }
    }
    return giftMessageGciData;
};

const subscriptionConfig = {
    subscription_keys: ['subscription_duration', 'subscription_type', 'subscription_interval'],
    subscription_type: [
        'basic',
        'discovery',
        'basic1',
        'basic2',
        'basic3',
        'monthOnlyPayFull',
        'monthOnly',
    ],
    subscription_duration: {
        1: 'Continue until I stop',
        3: 'Three Months',
        6: 'Six Months',
        9: 'Nine Months',
        12: 'Twelve Months',
    },
    subscription_interval: {
        1: 'Every Week',
        30: 'Monthly',
        2: 'Every 2 Weeks',
        4: 'Every 4 Weeks',
        6: 'Every 6 Weeks',
        60: 'BiMonthly',
        8: 'Every 8 Weeks',
        365: 'Annual',
    },
};

// Use for currency format for ex:
// 1000 => 1,000.00
// 80000 => 80,000.00
// 1000000 => 1,000,000.00
export const setCurrencyFormatforTotalOrder = (totalPrice) => {
    if (totalPrice || totalPrice === 0) {
        return parseFloat(Number(totalPrice)).toFixed(2).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    }
    return 0.00;
};

export const getTodayCutoffTimeProduct = (date, brandId, brandCutOffTime) => {
    let dateCutOffTime = null;
    let cutOffTime = null;

    if (brandId && brandCutOffTime?.[brandId] && date) {
        if (date.getDay() === 6) { // saturday
            cutOffTime = brandCutOffTime?.[brandId].saturday;
        } else if (date.getDay() === 0) { // sunday
            cutOffTime = brandCutOffTime?.[brandId].sunday;
        }  else {
            cutOffTime = brandCutOffTime?.[brandId].weekday;
        }

        if (cutOffTime && cutOffTime.hour) {
            dateCutOffTime = date;
            dateCutOffTime.setHours(cutOffTime.hour, cutOffTime.minutes, 0, 0);
        }
    }

    return dateCutOffTime;
};

export const getTimeZoneDate = (timeZone, date, isProductDate = false) => {
    let dateWithTimeZone = new Date();
    // dateWithTimeZone.setDate(dateWithTimeZone.getDate() + 1); // only for testing developers
    if (date) {
        dateWithTimeZone = date;
    }

    if (timeZone) {
        dateWithTimeZone =  new Date(
            new Date(dateWithTimeZone)
                .toLocaleString(
                    'en-US',
                    { timeZone },
                ),
        );
    }
    if (isProductDate) {
        if (dateWithTimeZone.getDate() !== new Date(date).getDate()) {
            dateWithTimeZone.setDate(new Date(date).getDate());
            dateWithTimeZone.setHours(0);
            dateWithTimeZone.setMinutes(0);
        }
    }

    return dateWithTimeZone;
};

export {
    brandByCode,
    brandNameByCode,
    calendarMapPresentation,
    propertiesTypeByProduct,
    getNormalizeGiftMessageGCI,
    skuBuilderWithUnderscore,
    skuProductBuilder,
    getProductBaseCodeSku,
    subscriptionConfig,
};
